<!-- =========================================================================================
	File Name: TheNavbar.vue
	Description: Navbar component
	Component Name: TheNavbar
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative" style="z-index: 1000">
    <div class="vx-navbar-wrapper">
      <vs-navbar
        class="vx-navbar navbar-custom"
        :color="navbarColor"
        :class="classObj"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer mr-1"
          icon="MenuIcon"
          @click.stop="showSidebar"
        ></feather-icon>
        <p class="font-semibold">
          กรมสรรพสามิต
        </p>

        <vs-spacer></vs-spacer>

        <!-- NOTIFICATIONS -->
        <vx-tooltip text="เเจ้งเตือนทั่วไป" position="bottom">
          <vs-dropdown
            vs-custom-content
            vs-trigger-click
            class="cursor-pointer"
          >
            <feather-icon
              :badge="countNotifications"
              icon="BellIcon"
              class="cursor-pointer mt-1 mr-2"
              color="warning"
            ></feather-icon>
            <vs-dropdown-menu class="notification-dropdown dropdown-custom">
              <div
                class="notification-top text-center p-5 bg-primary text-white"
              >
                <h3 class="text-white">เเจ้งเตือนทั่วไป</h3>
                <p class="opacity-75">
                  {{ countNotifications > 10 ? 10 : countNotifications }} New
                </p>
              </div>

              <VuePerfectScrollbar
                ref="mainSidebarPs"
                class="scroll-area--nofications-dropdown p-0 mb-10"
                :settings="settings"
              >
                <ul class="bordered-items">
                  <li
                    v-for="ntf in notifications"
                    :key="ntf.index"
                    class="flex justify-between px-4 py-4 notification cursor-pointer"
                  >
                    <div
                      class="flex items-start"
                      @click="isActiveNotification(ntf.id, ntf.type)"
                    >
                      <!-- <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon> -->
                      <div class="mx-2">
                        <span class="font-medium block notification-title"
                          >{{ ntf.title }} ({{ ntf.status }})</span
                        >
                        <!-- :class="[`text-${ntf.category}`]" -->
                        <small>{{ ntf.detail }}</small>
                      </div>
                    </div>
                    <div>
                      <small class="mt-1 whitespace-no-wrap">{{
                        elapsedTime(ntf.createdAt)
                      }}</small
                      ><br />
                      <small
                        v-if="ntf.read == 'unread'"
                        class="mt-1 whitespace-no-wrap text-danger"
                        >ยังไม่อ่าน</small
                      >
                      <small v-else class="mt-1 whitespace-no-wrap text-success"
                        >อ่านเเล้ว</small
                      >
                    </div>
                  </li>
                </ul>
              </VuePerfectScrollbar>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vx-tooltip>

        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block">
            <!-- <small>Available</small> -->
          </div>
          <vs-dropdown
            vs-custom-content
            vs-trigger-click
            class="cursor-pointer"
          >
            <div class="con-img">
              <vs-avatar text="A" color="warning"></vs-avatar>
            </div>
            <vs-dropdown-menu>
              <ul style="min-width: 10rem">
                <li
                  v-if="$acl.check('hasRoleOnlySuperVisor')"
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="myProfile"
                >
                  <feather-icon
                    icon="UserIcon"
                    svgClasses="w-4 h-4"
                  ></feather-icon>
                  <span class="ml-2">โปรไฟล์</span>
                </li>
                <vs-divider
                  v-if="$acl.check('hasRoleOnlySuperVisor')"
                  class="m-1"
                ></vs-divider>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="logout"
                >
                  <feather-icon
                    icon="LogOutIcon"
                    svgClasses="w-4 h-4"
                  ></feather-icon>
                  <span class="ml-2">ออกจากระบบ</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
// eslint-disable-next-line
import { SERVER_SYNC_INTERVAL, API_BASE_URL } from "../../constants/index";
import { io } from "socket.io-client";
let socket = io(`${API_BASE_URL}`);
// let socket = io("http://localhost:8082");
import { mapState, mapGetters } from "vuex";
import { formatNumber } from "@/utils/index";

export default {
  // eslint-disable-next-line
  name: "the-navbar",
  directives: {
    "click-outside": {
      bind: function (el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },

      unbind: function (el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  components: {
    VxAutoSuggest,
    VuePerfectScrollbar,
    draggable,
  },
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      formatNumber,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      unreadNotifications: [
        // { index: 0, title: 'New Message', msg: 'Are your going to meet me tonight?', icon: 'MessageSquareIcon', time: 'Wed Jan 30 2019 07:45:23 GMT+0000 (GMT)', category: 'primary' },
        // { index: 1, title: 'New Order Recieved', msg: 'You got new order of goods.', icon: 'PackageIcon', time: 'Wed Jan 30 2019 07:45:23 GMT+0000 (GMT)', category: 'success' },
        // { index: 2, title: 'Server Limit Reached!', msg: 'Server have 99% CPU usage.', icon: 'AlertOctagonIcon', time: 'Thu Jan 31 2019 07:45:23 GMT+0000 (GMT)', category: 'danger' },
        // { index: 3, title: 'New Mail From Peter', msg: 'Cake sesame snaps cupcake', icon: 'MailIcon', time: 'Fri Feb 01 2019 07:45:23 GMT+0000 (GMT)', category: 'primary' },
        // { index: 4, title: 'Bruce\'s Party', msg: 'Chocolate cake oat cake tiramisu', icon: 'CalendarIcon', time: 'Fri Feb 02 2019 07:45:23 GMT+0000 (GMT)', category: 'warning' },
      ],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
      serverSyncTimer: null,
      username: localStorage.getItem("accessUsername"),
      notifications: [],
      countNotifications: 0,
      // guardZoneNotifications: [],
      countGuardZoneNotifications: 0,
      amoutNotifacation: 0,
      ntfType: "guardZone",
      colorTabs: "primary",
    };
  },
  computed: {
    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == "default") return "navbar-default";
      else if (this.sidebarWidth == "reduced") return "navbar-reduced";
      else if (this.sidebarWidth) return "navbar-full";
    },

    // I18N
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "en") return { flag: "us", lang: "English" };
      else if (locale == "th") return { flag: "th", lang: "ภาษาไทย" };
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      },
    },

    // CART DROPDOWN
    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse();
    },

    // PROFILE
    user_displayName() {
      return JSON.parse(localStorage.getItem("userInfo")).displayName;
    },
    activeUserImg() {
      return (
        JSON.parse(localStorage.getItem("userInfo")).photoURL ||
        this.$store.state.AppActiveUser.img
      );
    },
    guardZoneNotifications() {
      return this.$store.state.rts.guardZoneNotifications;
    },
    overFlowTransfers() {
      return this.$store.state.mpTransferData.overFlowTransfers;
    },
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    },
  },
  created() {
    // this.serverSync();
    // this.serverSyncTimer = setInterval(this.serverSync, SERVER_SYNC_INTERVAL);
  },
  mounted() {
  },
  beforeDestroy() {
    clearInterval(this.serverSyncTimer);
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    },
    selected(item) {
      this.$router.push(item.url);
      this.showFullSearch = false;
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction,
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        // return seconds + (seconds > 1 ? `${seconds} sec ago` : "just now");
        return "Just now";
      }

      return "Just Now";
    },
    async logout() {
      await this.$store.dispatch("auth/logout");
      this.$router.push("/pages/login");

      // if user is looged in via firebase
      // const firebaseCurrentUser = firebase.auth().currentUser;

      // if (firebaseCurrentUser) {
      //   firebase
      //     .auth()
      //     .signOut()
      //     .then(() => {
      //       this.$router.push("/pages/login");
      //       // this.$router.go('/pages/login');
      //       this.$store.dispatch("auth/logout");
      //     });
      // }
      // // Change role on logout. Same value as initialRole of acj.js
      // this.$acl.change("ROLE_EDITOR");
    },
    myProfile() {
      const id = localStorage.getItem("accessUserId");
      this.$router.push(`/settings/me/${id}`);
    },
    outside: function () {
      this.showBookmarkPagesDropdown = false;
    },
    async readAllNotification() {
      console.log("อ่านแจ้งเตือนทั้งหมด");
      await this.$store.dispatch("notifications/readAll");
    },
    async readAllNoticOil() {
      console.log("อ่านแจ้งเตือนทั้งหมดของการเข้ารับน้ำมัน");
      await this.$store.dispatch("rts/readAllGuardZoneNotification");
      this.getGuardZoneNotifications();
    },
    getVolume(data) {
      return formatNumber(Number(data));
    },
  },
};
</script>
<style scoped>
.test {
  width: 25rem;
}
</style>
